"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _ButtressModule = _interopRequireDefault(require("./Buttress.module.css"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // https://css-tricks.com/aspect-ratio-boxes/


var Buttress = function Buttress(props) {
  var children = props.children,
      className = props.className,
      _props$aspectRatio = props.aspectRatio,
      aspectRatio = _props$aspectRatio === void 0 ? 1.6 : _props$aspectRatio,
      background = props.background,
      _props$overflowHidden = props.overflowHidden,
      overflowHidden = _props$overflowHidden === void 0 ? false : _props$overflowHidden;
  var style = {
    '--aspect-ratio': aspectRatio,
    background: background,
    overflow: overflowHidden ? 'hidden' : ''
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(_ButtressModule["default"], className),
    style: style
  }, children);
};

Buttress.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  aspectRatio: _propTypes["default"].number,
  background: _propTypes["default"].string,
  overflowHidden: _propTypes["default"].bool
};
var _default = Buttress;
exports["default"] = _default;